import React from 'react';
import RangeSlider from "react-rangeslider";
const ShortSelections = ({
  made2PT,
  miss2PT,
  shortSelectionsState,
  setShortSelectionsState,
  rangeValue,
  handleChange,
  actionPlayerId,
}) => {
  return (
    <div className="xxl:max-w-[570px] xxl:min-w-[570px] max-w-[244px] lg:max-w-[596px] lg:min-w-[596px] min-w-[244px]  w-full p-2 lg:p-6 pr-0 lg:pr-0 flex flex-wrap gap-[10px] lg:gap-[23px] justify-end">
      <div
        className={`${made2PT || miss2PT ? "max-w-[596px]" : "max-w-[386px]"
          } w-full flex flex-wrap gap-[10px] lg:gap-[23px]`}
      >
        {(made2PT === "active" || miss2PT === "active") && (
          <div
            onClick={() => setShortSelectionsState("hookShot")}
            className={`max-w-[72px] lg:max-w-[165px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[44px] flex justify-center items-center font-bebas text-[32px] lg:text-[44px] text-center cursor-pointer ${shortSelectionsState == "hookShot"
              ? "bg-[#419066] text-white"
              : " text-[#C08C5E] "
              }`}
            style={{
              boxShadow:
                "4px 4px 6px 0px #CCCCCCA6, -6px -4px 4px 0px #FFFFFF80",
            }}
          >
            Hook Shot
          </div>
        )}

        <div
          onClick={() => setShortSelectionsState("jumpShot")}
          className={`max-w-[72px] lg:max-w-[165px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[44px] flex justify-center items-center font-bebas text-[32px] lg:text-[44px] text-center
              ${shortSelectionsState == "jumpShot"
              ? "bg-[#419066] text-white"
              : " text-[#C08C5E] "
            } cursor-pointer`}
          style={{
            boxShadow:
              "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          Jump Shot
        </div>
        {(made2PT === "active" || miss2PT === "active") && (
          <div
            onClick={() => setShortSelectionsState("drivingLayup")}
            className={`max-w-[72px] lg:max-w-[165px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[44px] flex justify-center items-center font-bebas text-[32px] lg:text-[44px] text-center
              ${shortSelectionsState == "drivingLayup"
                ? "bg-[#419066] text-white"
                : " text-[#C08C5E] "
              } cursor-pointer`}
            style={{
              boxShadow:
                "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
            }}
          >
            Driving Layup
          </div>
        )}

        <div
          onClick={() => setShortSelectionsState("stepBackJumpShot")}
          className={`max-w-[72px] lg:max-w-[165px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[44px] flex justify-center items-center font-bebas text-[32px] lg:text-[44px] text-center
              ${shortSelectionsState == "stepBackJumpShot"
              ? "bg-[#419066] text-white"
              : " text-[#C08C5E] "
            } cursor-pointer`}
          style={{
            boxShadow:
              "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          Step Back Jump Shot
        </div>
        {(made2PT === "active" || miss2PT === "active") && (
          <div
            onClick={() => setShortSelectionsState("floatingJumpShot")}
            className={`max-w-[72px] lg:max-w-[165px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[44px] flex justify-center items-center font-bebas text-[32px] lg:text-[44px] text-center
              ${shortSelectionsState == "floatingJumpShot"
                ? "bg-[#419066] text-white"
                : " text-[#C08C5E] "
              } cursor-pointer`}
            style={{
              boxShadow:
                "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
            }}
          >
            Floating Jump Shot
          </div>
        )}
        <div
          onClick={() => setShortSelectionsState("pullUpJumpShot")}
          className={`max-w-[72px] lg:max-w-[165px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[44px] flex justify-center items-center font-bebas text-[32px] lg:text-[44px] text-center
              ${shortSelectionsState == "pullUpJumpShot"
              ? "bg-[#419066] text-white"
              : " text-[#C08C5E] "
            } cursor-pointer`}
          style={{
            boxShadow:
              "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          Pull Up Jump Shot
        </div>

        {(made2PT === "active" || miss2PT === "active") && (
          <div
            onClick={() => setShortSelectionsState("dunk")}
            className={`max-w-[72px] lg:max-w-[165px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px] lg:leading-[44px] flex justify-center items-center font-bebas text-[32px] lg:text-[44px] text-center
              ${shortSelectionsState == "dunk"
                ? "bg-[#419066] text-white"
                : " text-[#C08C5E] "
              } cursor-pointer`}
            style={{
              boxShadow:
                "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
            }}
          >
            Dunk
          </div>
        )}

        {(made2PT === "active" || miss2PT === "active") && (
          <div
            onClick={() => setShortSelectionsState("alleyOop")}
            className={`max-w-[72px] lg:max-w-[165px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[44px] flex justify-center items-center font-bebas text-[32px] lg:text-[44px] text-center
              ${shortSelectionsState == "alleyOop"
                ? "bg-[#419066] text-white"
                : " text-[#C08C5E] "
              } cursor-pointer`}
            style={{
              boxShadow:
                "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
            }}
          >
            Alley Oop
          </div>
        )}
        <div
          onClick={() => setShortSelectionsState("turnAroundJumpShot")}
          className={`max-w-[72px] lg:max-w-[165px] w-full h-[100px] lg:h-[262px] rounded-[3.39px] lg:rounded-lg  leading-[32.91px]  lg:leading-[44px] flex justify-center items-center font-bebas text-[32px] lg:text-[44px] text-center
              ${shortSelectionsState == "turnAroundJumpShot"
              ? "bg-[#419066] text-white"
              : " text-[#C08C5E] "
            } cursor-pointer`}
          style={{
            boxShadow:
              "4px 4px 6px 0px #CCCCCCA6,-6px -4px 4px 0px #FFFFFF80",
          }}
        >
          Turn around Jump Shot
        </div>
      </div>

      <div className="flex items-center justify-between w-full h-[50px]">
        <div
          // onClick={() => handlePlayerShot(actionPlayerId)}
          className="font-bebas text-[#4A4A4A] text-[10px] lg:text-base "
        >
          Fast break
        </div>
        <div className="max-w-[138px] lg:max-w-[392px] w-full bg-white px-3  rounded border-[1px] border-[#CCCCCC]">
          <RangeSlider
            min={0}
            max={100}
            tooltip={false}
            step={50}
            value={rangeValue}
            onChange={handleChange}
            actionPlayerId={actionPlayerId}
          />
        </div>
        <div className="font-bebas text-[#4A4A4A] text-[10px] lg:text-base ">
          No Fast Break
        </div>
      </div>
    </div>
  );
};

export default ShortSelections;